import React, {useState, useEffect} from "react";
import {Link} from '@mui/material/';
import axios from "axios";
import {useSearchParams} from "react-router-dom";
import * as constants from './../constants'
import MenuAppBar from "../components/MenuAppBar";
import {Button, List, ListItem, Typography} from "@mui/material";
import TextInput from "../components/TextInput";

const MainPage = () => {
    const [message, setMessage] = useState("")
    const [error, setError] = useState('')
    const [isMentor, setIsMentor] = useState(false)
    const [isMentee, setIsMentee] = useState(false)

    useEffect(() => {
        if (window.location.href.split('?message=')[1]) {
            if (window.location.href.split('?message=')[1] === 'success' && !isMentor) {
                setMessage("Nice three pointer ARISE student athlete! Now attend your session and pick a topic for your next 3 point score!")
            }
        }
        axios.post(constants.serverURL + "getSurveyStep", [],      {
            withCredentials: true,
        }).then(response => {
            if (response.data.step === 0) {
                window.location.href = constants.websiteURL + "#/phone?status=mentee"
            } else if (response.data.step === 1) {
                window.location.href = constants.websiteURL + "#/menteeForm"
            } else if (response.data.step === 2) {
                setIsMentee(true)
                //window.location.href = constants.websiteURL + "#/topMentors"
            }  else if (response.data.step === 7) {
                window.location.href = constants.websiteURL + "#/phone?status=mentor"
            } else if (response.data.step === 8) {
                window.location.href = constants.websiteURL + "#/mentorForm"
            } else if (response.data.step === 9) {
                window.location.href = constants.websiteURL + "#/uploadImage"
            } else if (response.data.step === 10) {
                setMessage("Thank you for completing the survey!")
                setIsMentor(true)
            }
        }).catch((error) => {
            if (error.request.responseText === 'expired token') {
                window.location.href = constants.websiteURL + '#/refreshToken?redirect=main'
            } else {
                setError(error.request.responseText)
                window.location.href = constants.websiteURL + "#/"
            }
        },[])
    })
    return (
        <div>
            <MenuAppBar title="" signedIn={true}></MenuAppBar>
            <List>
                {
                    error &&
                    <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                        <Typography className="font-16 error-message">{error}</Typography>
                    </ListItem>
                }
                {
                    message &&
                    <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                        <Typography className="font-16">{message}</Typography>
                    </ListItem>
                }
                <h1>
                    {isMentor &&
                        <div>
                            {/*<Button href="#/sessions" className="button" variant="outlined">*/}
                            {/*    Check upcoming sessions*/}
                            {/*</Button>*/}
                            <br/>
                            <Button href="#/updateSchedule" className="button" variant="outlined">
                                Change schedule
                            </Button>
                            <br/>
                            <Button href="#/mentorForm" className="button" variant="outlined">
                                Take the survey again
                            </Button>
                            <br/>
                            <Button href="#/uploadImage" className="button" variant="outlined">
                                Upload picture again
                            </Button>

                        </div>
                    }
                    {isMentee &&
                        <div>
                            <Button href="#/topMentors" className="button" variant="outlined">Schedule another mentor session</Button>
                            <br/>
                            <Button href="#/sessions" className="button" variant="outlined">Check or cancel upcoming sessions</Button>
                            <br/>
                            <Button href="#/menteeForm" className="button" variant="outlined">Take the survey again</Button>
                        </div>
                    }
                </h1>
            </List>
        </div>
    );
};

export default MainPage;